import { FC } from 'react';

export interface ClockGlyphProps {
    /** Время, которое показывают стрелки (обычно целевой момент напоминания). */
    date: Date;
    /** Сторона иконки в px, по умолчанию 18 (как прочие иконки меню). */
    size?: number;
    className?: string;
}

// Геометрия строго по MdOutlineSchedule (react-icons/md): обод-кольцо r9 толщиной 2
// (внешн. Ø20 / внутр. Ø16), стрелки толщиной 1.5 с плоскими торцами. Часовая длиной 4.8,
// минутная — 6 (зазор до внутр. края обода ≈2, не касается). Центрального сочленения нет — как в иконке.
const RING_R = 9;
const RING_W = 2;
const HAND_W = 1.5;
const HOUR_LEN = 4.8;
const MIN_LEN = 6;

/** Кончик стрелки: угол от 12 часов по часовой стрелке, длина от центра (12, 12). */
const tip = (angleDeg: number, len: number): [string, string] => {
    const rad = ((angleDeg - 90) * Math.PI) / 180;
    return [(12 + len * Math.cos(rad)).toFixed(2), (12 + len * Math.sin(rad)).toFixed(2)];
};

/**
 * Мини-циферблат со стрелками на переданное время — в стиле статичной `MdOutlineSchedule`,
 * но с реальным положением стрелок. Используется в меню «Отложить» для пресетов
 * «через 30 минут» / «через час»: иконка показывает, во сколько напомнят.
 */
const ClockGlyph: FC<ClockGlyphProps> = ({ date, size = 18, className }: ClockGlyphProps) => {
    const h = date.getHours() % 12;
    const m = date.getMinutes();
    const [hx, hy] = tip(h * 30 + m * 0.5, HOUR_LEN);
    const [mx, my] = tip(m * 6, MIN_LEN);
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            aria-hidden="true"
        >
            <circle cx="12" cy="12" r={RING_R} strokeWidth={RING_W} />
            <line x1="12" y1="12" x2={hx} y2={hy} strokeWidth={HAND_W} strokeLinecap="butt" />
            <line x1="12" y1="12" x2={mx} y2={my} strokeWidth={HAND_W} strokeLinecap="butt" />
        </svg>
    );
};

export default ClockGlyph;
